import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Redirect } from "react-router";

import { getPromoSlides } from "../../../../services/promoSlider/actions";
import { getSingleLanguageData } from "../../../../services/languages/actions";
import { getUserNotifications } from "../../../../services/alert/actions";
import { resetInfo, resetItems, getHomeProducts } from "../../../../services/items/actions";
import { getDeliveryRestaurants } from "../../../../services/restaurant/actions";
import { getBrands } from "../../../../services/brands/actions";
import { addPhase2Product, removePhase2Product } from "../../../../services/cart/actions";
import { getImageUrl } from "../../../../helpers/imageUrl";
import { setAppMode, initializeAppMode } from "../../../../services/settings/actions";
import { AppMode } from "../../../../constants";
import Footer from "../../Footer";
import HomePromoBanner from "../../Home/HomePromoBanner";

import { isDesktopViewport } from "../../../../helpers/viewport.js";
import { formatStoreRating } from "../../../../helpers/storeRating";
const FA = {
    zLogo:       "/assets/img/phase2-home/z-logo.png",
    magnify:     "/assets/img/phase2-home/magnify.svg",
    mapPin:      "/assets/img/phase2-home/map-pin.svg",
    pill1:       "/assets/img/phase2-home/pill1.svg",
    pill2:       "/assets/img/phase2-home/pill2.svg",
    delivIcon:   "/assets/img/phase2-home/deliv-icon.png",
    starIcon:    "/assets/img/phase2-home/star-icon.svg",
    lightIcon:   "/assets/img/phase2-home/light-icon.svg",
    heartFav:    "/assets/img/buttons/heart-favorite.svg",
};

const RELAY_CATEGORIES = [
    { name: "Cloths",      icon: "/assets/img/phase2-home/categories/cloths.png",      ellipse: "/assets/img/phase2-home/categories/ellipse-pink.svg" },
    { name: "Watch",       icon: "/assets/img/phase2-home/categories/watch.png",       ellipse: "/assets/img/phase2-home/categories/ellipse-green.svg" },
    { name: "Bags",        icon: "/assets/img/phase2-home/categories/bags.png",        ellipse: "/assets/img/phase2-home/categories/ellipse-green.svg" },
    { name: "Sandals",     icon: "/assets/img/phase2-home/categories/sandals.png",     ellipse: "/assets/img/phase2-home/categories/ellipse-green.svg" },
    { name: "Accessories", icon: "/assets/img/phase2-home/categories/accessories.png", ellipse: "/assets/img/phase2-home/categories/ellipse-blue.svg" },
];

const RELAY_MOCK_STORES = [
    { id: 1, name: "Manyavar",      discount: "20% Off", deliveryTime: "2-3 Days",   rating: "4.5", image: "/assets/img/phase2-home/stores/manyavar.png",      slug: null },
    { id: 2, name: "RMKV Silks",    discount: "30% Off", deliveryTime: "1-2 Days",   rating: "4.5", image: "/assets/img/phase2-home/stores/rmkv-silks.jpg",    slug: null },
    { id: 3, name: "Kalyan Sarees", discount: "30% Off", deliveryTime: "3-4 Days",   rating: "4.5", image: "/assets/img/phase2-home/stores/kalyan-sarees.png", slug: null },
    { id: 4, name: "Koskii",        discount: "20% Off", deliveryTime: "1-2 Days",   rating: "4.5", image: "/assets/img/phase2-home/stores/koskii.png",        slug: null },
    { id: 5, name: "Anokhi",        discount: "40% Off", deliveryTime: "1-2 Days",   rating: "4.5", image: "/assets/img/phase2-home/stores/anokhi.png",        slug: null },
    { id: 6, name: "Nalli",         discount: "10% Off", deliveryTime: "20-30 mins", rating: "4.5", image: "/assets/img/phase2-home/stores/nalli.png",         slug: null },
];

const MOCK_DISCOUNTS = ["20% Off", "30% Off", "10% Off", "40% Off", "15% Off", "25% Off", "35% Off", "50% Off"];

const FONT = "'Montserrat', sans-serif";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAddress: null,
            animatingToMode: null,
        };
    }

    // ── Helpers ───────────────────────────────────────────────────────────────
    loadCurrentAddress = () => {
        let addr = null;
        const raw = localStorage.getItem("userSetAddress");
        if (raw) {
            try { const p = JSON.parse(raw); if (p && p.address) addr = p; } catch (e) { /* ignore */ }
        }
        if (!addr && this.props.user?.data?.default_address)
            addr = this.props.user.data.default_address;
        return addr;
    };

    handleToggle = (mode) => {
        const target = mode === "Quick Commerce" ? AppMode.SPRINT : AppMode.RELAY;
        if (target === AppMode.RELAY) {
            this.setState({ rushHint: true });
            clearTimeout(this.rushHintTimer);
            this.rushHintTimer = setTimeout(() => this.setState({ rushHint: false }), 2200);
            return;
        }
        if (this.props.appMode === target) return;
        this.setState({ animatingToMode: target });
        setTimeout(() => {
            if (target === AppMode.SPRINT) {
                this.props.setAppMode(AppMode.SPRINT);
                this.props.history.push("/home", { modeSwitch: true, showAnimation: false });
            } else {
                this.props.history.replace(this.props.history.location.pathname, { modeSwitch: true });
                this.props.setAppMode(AppMode.RELAY);
                const raw = localStorage.getItem("userSetAddress");
                if (raw) {
                    const addr = JSON.parse(raw);
                    this.props.getHomeProducts(addr.lat, addr.lng, addr.state || "Karnataka", AppMode.RELAY, false);
                }
            }
        }, 350);
    };

    // ── Lifecycle ──────────────────────────────────────────────────────────────
    async componentDidMount() {
        const addr = this.loadCurrentAddress();
        if (addr) this.setState({ currentAddress: addr });

        const raw = localStorage.getItem("userSetAddress");
        if (raw) {
            const userSetAddress = JSON.parse(raw);
            const token = this.props.user?.data?.auth_token || null;
            const uid   = this.props.user?.data?.id || null;
            this.props.getDeliveryRestaurants(userSetAddress.lat, userSetAddress.lng, token, uid);
            this.props.getHomeProducts(userSetAddress.lat, userSetAddress.lng, userSetAddress.state || "Karnataka", AppMode.RELAY, false);
            if (localStorage.getItem("showPromoSlider") === "true" && this.props.user?.data) {
                this.props.getPromoSlides(userSetAddress.lat, userSetAddress.lng, token, uid);
            }
            if (this.props.user?.success) this.props.getUserNotifications(uid, token);
        }

        // Brands power the Relax store grid (location-independent).
        this.props.getBrands();

        this.storageCheckInterval = setInterval(() => {
            const newAddr = this.loadCurrentAddress();
            if (JSON.stringify(newAddr) !== JSON.stringify(this.state.currentAddress)) {
                this.setState({ currentAddress: newAddr });
            }
        }, 500);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user) {
            this.setState({ currentAddress: this.loadCurrentAddress() });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.languages !== nextProps.languages) {
            const pref = localStorage.getItem("userPreferedLanguage");
            if (pref) {
                this.props.getSingleLanguageData(pref);
            } else if (nextProps.languages?.length) {
                const def = nextProps.languages.find((l) => l.is_default === 1);
                if (def) this.props.getSingleLanguageData(def.id);
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.rushHintTimer);
        if (this.storageCheckInterval) clearInterval(this.storageCheckInterval);
    }

    // ── Store card ────────────────────────────────────────────────────────────
    renderStoreCard(store, index, isRealStore) {
        const discount     = isRealStore ? MOCK_DISCOUNTS[index % MOCK_DISCOUNTS.length] : store.discount;
        const deliveryTime = isRealStore ? (store.delivery_time || "2-3 Days") : store.deliveryTime;
        const rating       = isRealStore
            ? formatStoreRating(store)
            : store.rating;
        const image        = isRealStore ? getImageUrl(store.image) : store.image;
        const slug         = isRealStore ? store.slug : null;
        const isMins       = deliveryTime && deliveryTime.includes("min");

        const card = (
            <div style={{ borderRadius: "9px", overflow: "hidden", background: "#1a1333", marginBottom: "8px" }}>
                {/* Image area */}
                <div style={{ position: "relative", height: "109px", background: "#2a1e52", overflow: "hidden" }}>
                    <img
                        src={image}
                        alt={store.name}
                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                        onError={(e) => { e.target.src = "/assets/img/various/shop-placeholder.jpeg"; }}
                    />
                    {/* Discount badge */}
                    <div style={{ position: "absolute", top: 0, left: 0, background: "rgba(0,0,0,0.7)", borderBottomRightRadius: "9px", padding: "3px 7px" }}>
                        <span style={{ fontSize: "8px", fontWeight: 600, color: "#fff", fontFamily: FONT }}>{discount}</span>
                    </div>
                    {/* Glassmorphism favorite button */}
                    <div
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        style={{
                            position: "absolute", top: "6px", right: "6px", width: "28px", height: "28px",
                            borderRadius: "50%", border: "0.5px solid #eabfff",
                            background: "radial-gradient(ellipse at 30% 40%, rgba(165,239,255,0.2) 0%, rgba(110,191,244,0.05) 77%, rgba(70,144,212,0.2) 100%)",
                            backdropFilter: "blur(40px)", WebkitBackdropFilter: "blur(40px)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "pointer", zIndex: 2,
                        }}
                    >
                        <img src={FA.heartFav} alt="" style={{ width: "14px", height: "12px" }} />
                    </div>
                    {/* Rating badge: real customer average only; hidden until a store has votes */}
                    {rating && (
                    <div style={{ position: "absolute", bottom: "4px", right: "4px", background: "#271a46", borderRadius: "3px", width: "28px", height: "17px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div style={{ background: "#fff", borderRadius: "3px", width: "21px", height: "11px", display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                            <img src={FA.starIcon} alt="★" style={{ width: "5px", height: "5px" }} />
                            <span style={{ fontSize: "7px", fontWeight: 600, color: "#0f0000", fontFamily: FONT }}>{rating}</span>
                        </div>
                    </div>
                    )}
                </div>
                {/* Info */}
                <div style={{ background: "#271a46", padding: "6px 6px 8px", minHeight: "54px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <p style={{ margin: "0 0 4px", fontSize: "12px", fontWeight: 600, color: "#fff", fontFamily: FONT, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {store.name}
                    </p>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <img src={isMins ? FA.lightIcon : FA.delivIcon} alt="" style={{ width: isMins ? "4px" : "7px", height: isMins ? "7px" : "8px", opacity: 0.85 }} />
                        <span style={{ fontSize: "9px", color: "#fff", fontFamily: FONT }}>{deliveryTime}</span>
                    </div>
                </div>
            </div>
        );

        if (slug) {
            return <Link key={store.id} to={`/stores/${slug}`} style={{ textDecoration: "none" }}>{card}</Link>;
        }
        return (
            <div key={store.id || store.name + index} style={{ cursor: "pointer" }}
                onClick={() => this.props.history.push("/relax/explore")}>
                {card}
            </div>
        );
    }

    // ── Brand card ──────────────────────────────────────────────────────────────
    // Same visual treatment as the store card (dark info-bar per Figma), but the
    // data comes from the brands API and the card links to the brand items page.
    renderBrandCard(brand, index) {
        const discount     = MOCK_DISCOUNTS[index % MOCK_DISCOUNTS.length];
        const itemsCount   = brand.items_count || 0;
        const subLine      = itemsCount > 0 ? `${itemsCount} products` : "View brand";
        const rating       = "4.5";
        const image        = brand.image ? getImageUrl(brand.image) : "/assets/img/various/shop-placeholder.jpeg";
        const name         = brand.brand_name || brand.name || "Brand";

        const card = (
            <div style={{ borderRadius: "9px", overflow: "hidden", background: "#1a1333", marginBottom: "8px" }}>
                <div style={{ position: "relative", height: "109px", background: "#2a1e52", overflow: "hidden" }}>
                    {/* contain: the whole brand image is shown (portrait images were being cropped by cover) */}
                    <img
                        src={image}
                        alt={name}
                        style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center", display: "block" }}
                        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/various/shop-placeholder.jpeg"; }}
                    />
                    <div style={{ position: "absolute", top: 0, left: 0, background: "rgba(0,0,0,0.7)", borderBottomRightRadius: "9px", padding: "3px 7px" }}>
                        <span style={{ fontSize: "8px", fontWeight: 600, color: "#fff", fontFamily: FONT }}>{discount}</span>
                    </div>
                    <div style={{ position: "absolute", bottom: "4px", right: "4px", background: "#271a46", borderRadius: "3px", width: "28px", height: "17px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div style={{ background: "#fff", borderRadius: "3px", width: "21px", height: "11px", display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                            <img src={FA.starIcon} alt="★" style={{ width: "5px", height: "5px" }} />
                            <span style={{ fontSize: "7px", fontWeight: 600, color: "#0f0000", fontFamily: FONT }}>{rating}</span>
                        </div>
                    </div>
                </div>
                <div style={{ background: "#271a46", padding: "6px 6px 8px", minHeight: "54px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <p style={{ margin: "0 0 4px", fontSize: "12px", fontWeight: 600, color: "#fff", fontFamily: FONT, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {name}
                    </p>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <span style={{ fontSize: "9px", color: "#fff", fontFamily: FONT }}>{subLine}</span>
                    </div>
                </div>
            </div>
        );

        return (
            <Link key={brand.id || name + index} to={`/relax/brand/${brand.id}`} style={{ textDecoration: "none" }}>
                {card}
            </Link>
        );
    }

    // ── Skeleton ──────────────────────────────────────────────────────────────
    renderSkeleton() {
        return [0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} style={{ borderRadius: "9px", overflow: "hidden", marginBottom: "8px" }}>
                <div style={{ height: "109px", background: "#e8e0f0" }} />
                <div style={{ background: "#f0ebf8", padding: "6px", minHeight: "54px" }}>
                    <div style={{ height: "12px", width: "70%", background: "#ddd6ea", borderRadius: "4px", marginBottom: "6px" }} />
                    <div style={{ height: "9px", width: "40%", background: "#ddd6ea", borderRadius: "4px" }} />
                </div>
            </div>
        ));
    }

    // ── Render ────────────────────────────────────────────────────────────────
    render() {
        if (isDesktopViewport()) return <Redirect to="/" />;
        const raw = localStorage.getItem("userSetAddress");
        if (!raw) return <Redirect to="/" />;
        const userSetAddress = JSON.parse(raw);
        if (Object.keys(userSetAddress).length === 0) return <Redirect to="/" />;

        const { user, restaurants, appMode, promo_slides } = this.props;
        const { animatingToMode, currentAddress } = this.state;

        const addressText   = currentAddress?.address || "";
        const shortAddr     = addressText.length > 35 ? addressText.slice(0, 35) + "…" : addressText;
        const isRelaxMode   = (animatingToMode || appMode) !== AppMode.SPRINT;

        // Relax mode surfaces brands (not restaurants). Fall back to the mock
        // store grid while brands are loading / if none are returned.
        const { brands, brandsLoading } = this.props;
        const brandList     = Array.isArray(brands) && brands.length > 0 ? brands : null;
        const displayBrands = brandList ? brandList.slice(0, 24) : null;

        const storeList     = Array.isArray(restaurants) && restaurants.length > 0 ? restaurants : null;
        const isLoading     = brandsLoading && !brandList;
        const displayStores = storeList ? storeList.slice(0, 12) : RELAY_MOCK_STORES;

        return (
            // ── WHITE background for Relay ─────────────────────────────────────
            <div style={{ minHeight: "100vh", background: "#fff", fontFamily: FONT }}>

                {/* ── STICKY HEADER (white) ──────────────────────────────────── */}
                <div style={{
                    position: "sticky", top: 0, zIndex: 50,
                    background: "#fff",
                    borderBottom: "0.5px solid #f0ebff",
                    paddingBottom: "4px",
                }}>
                    {/* Row 1: Z logo + search + pills */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 16px 4px" }}>
                        <img src={FA.zLogo} alt="logo" style={{ width: "36px", height: "40px", objectFit: "contain", flexShrink: 0, marginRight: "2px" }} />

                        <div
                            onClick={() => this.props.history.push("/relax/explore")}
                            style={{
                                flex: 1,
                                minWidth: 0,
                                display: "flex",
                                alignItems: "center",
                                height: "44px",
                                borderRadius: "129px",
                                padding: "0 14px",
                                gap: "8px",
                                boxSizing: "border-box",
                                background: "#f7f2ff",
                                border: "1px solid #e4d5ff",
                                boxShadow: "0 2px 10px rgba(135,81,181,0.10)",
                                cursor: "pointer",
                            }}
                        >
                            <img src={FA.magnify} alt="search" style={{ width: "20px", height: "20px", flexShrink: 0 }} />
                            <span style={{ color: "#a9a2bf", fontSize: "12px", fontWeight: 500, fontFamily: FONT, flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                Search stores & products
                            </span>
                        </div>

                    </div>

                    {/* Row 2: location (dark text on white) */}
                    <div style={{ display: "flex", alignItems: "center", padding: "9px 16px 8px" }}>
                        <img src={FA.mapPin} alt="" style={{ width: "18px", height: "18px", marginRight: "6px", flexShrink: 0 }} />
                        <span style={{ flex: 1, fontSize: "12px", fontWeight: 500, color: "#000", fontFamily: FONT, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {shortAddr || "Select your location"}
                        </span>
                        <Link
                            to={user?.success ? "/my-addresses" : "/search-location"}
                            style={{ fontSize: "12px", fontWeight: 600, color: "#00c026", marginLeft: "8px", whiteSpace: "nowrap", textDecoration: "none", fontFamily: FONT }}
                        >
                            Change
                        </Link>
                    </div>
                </div>

                {/* ── PROMO BANNER ──────────────────────────────────────────────── */}
                <div style={{ padding: "12px 16px 16px" }}>
                    <HomePromoBanner
                        slides={
                            promo_slides &&
                            localStorage.getItem("showPromoSlider") === "true" &&
                            promo_slides.mainSlides &&
                            promo_slides.mainSlides.length > 0
                                ? promo_slides.mainSlides
                                : []
                        }
                    />
                </div>

                {/* ── RUSH / RELAX TOGGLE ───────────────────────────────────────── */}
                <div style={{ padding: "0 17px 20px" }}>
                    <div style={{
                        display: "flex", height: "37px",
                        background: "#271b47", border: "0.5px solid #bb7eff",
                        borderRadius: "18px", overflow: "hidden", position: "relative",
                    }}>
                        <div style={{
                            position: "absolute",
                            left: isRelaxMode ? "50%" : 0,
                            width: "50%", height: "100%",
                            background: "#b0055a", border: "0.5px solid #ee499b",
                            borderRadius: "18px",
                            transition: "left 0.35s ease",
                        }} />
                        {["Quick Commerce", "Relax"].map((m) => {
                            const isActive = isRelaxMode ? m === "Relax" : m === "Quick Commerce";
                            return (
                                <button
                                    key={m}
                                    onClick={() => this.handleToggle(m)}
                                    style={{
                                        flex: 1, zIndex: 1, position: "relative",
                                        background: "transparent", border: "none",
                                        fontSize: "13px", fontWeight: 600, fontFamily: FONT,
                                        color: isActive ? "#fff" : "#e2e2e2", cursor: "pointer",
                                    }}
                                >
                                    {m === "Relax" ? (
                    <span style={{ display:"inline-flex", alignItems:"center", gap:"6px", opacity:0.75 }}>
                      Relax
                      <span style={{ fontSize:"8px", fontWeight:700, letterSpacing:"0.4px", textTransform:"uppercase", padding:"2px 6px", borderRadius:"8px", background:"rgba(255,255,255,0.18)", border:"0.5px solid rgba(255,255,255,0.35)" }}>Soon</span>
                    </span>
                  ) : "Rush"}
                                </button>
                            );
                        })}
                    </div>
          {this.state.rushHint && (
            <div role="status" style={{ marginTop:"8px", textAlign:"center", fontSize:"12px", fontWeight:600, fontFamily:FONT, color:"#6b21a8" }}>
              Relax is coming soon. Enjoy Rush for now!
            </div>
          )}
                </div>

                {/* ── CATEGORIES ────────────────────────────────────────────────── */}
                <div style={{
                    display: "flex", padding: "0 12px 20px",
                    overflowX: "auto", scrollbarWidth: "none",
                    WebkitOverflowScrolling: "touch",
                    touchAction: "pan-x pan-y",
                    justifyContent: "space-between",
                }}>
                    {RELAY_CATEGORIES.map((cat) => (
                        <div
                            key={cat.name}
                            onClick={() => this.props.history.push("/relax/explore")}
                            style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", cursor: "pointer", width: "58px" }}
                        >
                            <div style={{
                                width: "58px", height: "58px", borderRadius: "50%",
                                border: "1px solid #eabfff",
                                overflow: "hidden", position: "relative",
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                <img src={cat.ellipse} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                                <img src={cat.icon} alt={cat.name} style={{ width: "55%", height: "55%", objectFit: "contain", position: "relative", zIndex: 1 }} />
                            </div>
                            {/* Dark text on white background */}
                            <span style={{ fontSize: "9px", fontWeight: 500, color: "#333", fontFamily: FONT, textAlign: "center", maxWidth: "60px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {cat.name}
                            </span>
                        </div>
                    ))}
                </div>

                {/* ── STORE GRID (3 columns) ────────────────────────────────────── */}
                <div style={{ padding: "0 12px" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px" }}>
                        {isLoading
                            ? this.renderSkeleton()
                            : displayBrands
                                ? displayBrands.map((brand, i) => this.renderBrandCard(brand, i))
                                : displayStores.map((store, i) => this.renderStoreCard(store, i, !!storeList))
                        }
                    </div>
                </div>

                {/* ── SHARED FOOTER ─────────────────────────────────────────────── */}
                <Footer active_tab="home" />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user:               state.user.user,
    locations:          state.locations.locations,
    languages:          state.languages.languages,
    restaurants:        state.restaurants.restaurants,
    cartProducts:       state.cart.products,
    phase2CartProducts: state.cart.phase2Products || [],
    appMode:            state.settings.appMode,
    homeProducts:       state.items.homeProducts,
    brands:             state.brands ? state.brands.brands : [],
    brandsLoading:      state.brands ? state.brands.brandsLoading : false,
    promo_slides:       state.promo_slides.promo_slides,
});

export default connect(
    mapStateToProps,
    {
        getPromoSlides,
        getUserNotifications,
        resetInfo,
        resetItems,
        getSingleLanguageData,
        getDeliveryRestaurants,
        getBrands,
        getHomeProducts,
        setAppMode,
        initializeAppMode,
        addPhase2Product,
        removePhase2Product,
    }
)(withRouter(Home));
